// extracted by mini-css-extract-plugin
module.exports = {"menuToggler":"MenuToggler_menuToggler__8_MGj","menuToggler--open":"MenuToggler_menuToggler--open__BVoAF"};